export const repositoryConstants = {
  REPOSITORY_LOAD: '[Repository] Load',
  REPOSITORY_LOAD_SUCCESS: '[Repository] Load success',
  REPOSITORY_LOAD_FAILURE: '[Repository] Load failure',
  REPOSITORY_RESET: '[Repository] Reset'
}
